import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx2yltdocdrxs4d as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb1yxpplfe5vmm as Char__compareTo_impl_ypi4mb,
  toString336ienavfnzn0 as toString,
  Char__toInt_impl_vasixd1ka89vowck9tn as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.b4x_1 = 'Accept';
        this.c4x_1 = 'Accept-Charset';
        this.d4x_1 = 'Accept-Encoding';
        this.e4x_1 = 'Accept-Language';
        this.f4x_1 = 'Accept-Ranges';
        this.g4x_1 = 'Age';
        this.h4x_1 = 'Allow';
        this.i4x_1 = 'ALPN';
        this.j4x_1 = 'Authentication-Info';
        this.k4x_1 = 'Authorization';
        this.l4x_1 = 'Cache-Control';
        this.m4x_1 = 'Connection';
        this.n4x_1 = 'Content-Disposition';
        this.o4x_1 = 'Content-Encoding';
        this.p4x_1 = 'Content-Language';
        this.q4x_1 = 'Content-Length';
        this.r4x_1 = 'Content-Location';
        this.s4x_1 = 'Content-Range';
        this.t4x_1 = 'Content-Type';
        this.u4x_1 = 'Cookie';
        this.v4x_1 = 'DASL';
        this.w4x_1 = 'Date';
        this.x4x_1 = 'DAV';
        this.y4x_1 = 'Depth';
        this.z4x_1 = 'Destination';
        this.a4y_1 = 'ETag';
        this.b4y_1 = 'Expect';
        this.c4y_1 = 'Expires';
        this.d4y_1 = 'From';
        this.e4y_1 = 'Forwarded';
        this.f4y_1 = 'Host';
        this.g4y_1 = 'HTTP2-Settings';
        this.h4y_1 = 'If';
        this.i4y_1 = 'If-Match';
        this.j4y_1 = 'If-Modified-Since';
        this.k4y_1 = 'If-None-Match';
        this.l4y_1 = 'If-Range';
        this.m4y_1 = 'If-Schedule-Tag-Match';
        this.n4y_1 = 'If-Unmodified-Since';
        this.o4y_1 = 'Last-Modified';
        this.p4y_1 = 'Location';
        this.q4y_1 = 'Lock-Token';
        this.r4y_1 = 'Link';
        this.s4y_1 = 'Max-Forwards';
        this.t4y_1 = 'MIME-Version';
        this.u4y_1 = 'Ordering-Type';
        this.v4y_1 = 'Origin';
        this.w4y_1 = 'Overwrite';
        this.x4y_1 = 'Position';
        this.y4y_1 = 'Pragma';
        this.z4y_1 = 'Prefer';
        this.a4z_1 = 'Preference-Applied';
        this.b4z_1 = 'Proxy-Authenticate';
        this.c4z_1 = 'Proxy-Authentication-Info';
        this.d4z_1 = 'Proxy-Authorization';
        this.e4z_1 = 'Public-Key-Pins';
        this.f4z_1 = 'Public-Key-Pins-Report-Only';
        this.g4z_1 = 'Range';
        this.h4z_1 = 'Referer';
        this.i4z_1 = 'Retry-After';
        this.j4z_1 = 'Schedule-Reply';
        this.k4z_1 = 'Schedule-Tag';
        this.l4z_1 = 'Sec-WebSocket-Accept';
        this.m4z_1 = 'Sec-WebSocket-Extensions';
        this.n4z_1 = 'Sec-WebSocket-Key';
        this.o4z_1 = 'Sec-WebSocket-Protocol';
        this.p4z_1 = 'Sec-WebSocket-Version';
        this.q4z_1 = 'Server';
        this.r4z_1 = 'Set-Cookie';
        this.s4z_1 = 'SLUG';
        this.t4z_1 = 'Strict-Transport-Security';
        this.u4z_1 = 'TE';
        this.v4z_1 = 'Timeout';
        this.w4z_1 = 'Trailer';
        this.x4z_1 = 'Transfer-Encoding';
        this.y4z_1 = 'Upgrade';
        this.z4z_1 = 'User-Agent';
        this.a50_1 = 'Vary';
        this.b50_1 = 'Via';
        this.c50_1 = 'Warning';
        this.d50_1 = 'WWW-Authenticate';
        this.e50_1 = 'Access-Control-Allow-Origin';
        this.f50_1 = 'Access-Control-Allow-Methods';
        this.g50_1 = 'Access-Control-Allow-Credentials';
        this.h50_1 = 'Access-Control-Allow-Headers';
        this.i50_1 = 'Access-Control-Request-Method';
        this.j50_1 = 'Access-Control-Request-Headers';
        this.k50_1 = 'Access-Control-Expose-Headers';
        this.l50_1 = 'Access-Control-Max-Age';
        this.m50_1 = 'X-Http-Method-Override';
        this.n50_1 = 'X-Forwarded-Host';
        this.o50_1 = 'X-Forwarded-Server';
        this.p50_1 = 'X-Forwarded-Proto';
        this.q50_1 = 'X-Forwarded-For';
        this.r50_1 = 'X-Forwarded-Port';
        this.s50_1 = 'X-Request-ID';
        this.t50_1 = 'X-Correlation-ID';
        this.u50_1 = 'X-Total-Count';
        this.v50_1 = 'Last-Event-ID';
        this.w50_1 = 'TDM-Reservation';
        this.x50_1 = 'TDM-Policy';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.y50_1 = ['Transfer-Encoding', 'Upgrade'];
        this.z50_1 = asList(this.y50_1);
      }
      a51(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
            throw IllegalHeaderNameException().k51(name, _unary__edvuaz);
          }
        }
      }
      b51(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().r51(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(header) {
        return new.target.w51(header);
      }
      static w51(header) {
        var $this = this.n2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.v51_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
function isDelimiter(ch) {
  return contains('"(),/:;<=>?@[\\]{}', ch);
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerName, position) {
        return new.target.k51(headerName, position);
      }
      static k51(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.j51_1);
        $this.h51_1 = headerName;
        $this.i51_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      constructor(headerValue, position) {
        return new.target.r51(headerValue, position);
      }
      static r51(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.n2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.q51_1);
        $this.o51_1 = headerValue;
        $this.p51_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance3m47m69p49qfb,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
